import { usePageTitle } from './hooks/usePageTitle';

function ForgotEmail() {
  usePageTitle('Forgot Username');
  return (
    <div
      id="ts-login-wrapper"
      className="w-full h-full p-8 flex flex-col items-center justify-center"
    >
      <div
        id="ts-loginforgotemail-card"
        className="w-1/3 h-fit p-4 flex flex-col rounded-sm items-center justify-center border-light-border border shadow-sm"
      >
        <div
          id="ts-loginforgotemail-title"
          className="text-2xl font-bold mt-4"
        >
          Forgot your Email
        </div>

        <div id="ts-loginforgotemail-txt" className='p-4 text-md flex flex-col items-center'>
          Contact: <span className="cursor-pointer text-light-main">support@terrasciences.com</span> to recover your existing email to your account.
        </div>
      </div>
    </div>
  );
}

export default ForgotEmail;
